var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',_vm._l((_vm.amount),function(n){return _c('span',{key:n},[_c('span',{class:[_vm.stringToIcon, _vm.tendencyColors]})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }